import React, { Component, createRef } from "react";
import DataTable from './TableBase';
import { serviceColumns } from './RecordCells';
import { withRouter } from "react-router-dom";
import { apiCall } from "../../helpers/MainHelper";
import Swal from "sweetalert2";
import withPermissions from "../WithPermissions";
import ReactDOMServer from "react-dom/server";
import ReactLoading from "react-loading";

class ServicesTable extends Component {

    constructor(props) {
        super(props);
        this.tableRef = createRef();
        this.state = {
            pending: true,
            loading: false,
        }

    }
    handleServiceDetail = (serviceId) => {
        this.props.history.push(`/${this.props.isMotor ? 'service-moto-detail' : 'service-detail'}/${serviceId}`);
    }
    triggerFetch = (page = 1, size = 10, search = '') => {
        if (this.tableRef.current) {
            this.tableRef.current.fetchData(page, size, search);
        }
    };

    handleDelete = async (operationID) => {
        const result = await Swal.fire({
            title: 'Silmek istediğinize emin misiniz?',
            text: "Bu işlem geri alınamaz.Servise ait tüm veriler silinir!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Evet, sil!',
            cancelButtonText: 'Hayır, iptal et',
            preConfirm: async () => {
                const confirmButton = Swal.getConfirmButton();
                const originalButtonText = confirmButton.innerHTML;
                confirmButton.disabled = true;
                confirmButton.innerHTML = ReactDOMServer.renderToString(<ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />);

                try {
                    await apiCall('business/operation/delete/' + operationID, 'delete', null);
                    await this.triggerFetch();
                    return true;
                } catch (error) {
                    return false;
                } finally {
                    confirmButton.innerHTML = originalButtonText;
                    confirmButton.disabled = false;
                }
            }
        });

        if (result.isConfirmed) {
            if (result.value) {
                Swal.fire(
                    'Silindi!',
                    'Servis başarıyla silindi.',
                    'success'
                );
            } else {
                Swal.fire(
                    'Hata!',
                    'Silme işlemi başarısız oldu.',
                    'error'
                );
            }
        }
    }
    render() {
        const { pending } = this.state;
        const { userPermissions } = this.props;
        const userHasViewServicePermission = userPermissions.includes('view service');
        const userHasDeleteServicePermission = userPermissions.includes('delete service');
        const columns = serviceColumns({ motor: this.props.isMotor, canView: userHasViewServicePermission, canDelete: userHasDeleteServicePermission,
            onView: row => this.handleServiceDetail(row.id), onDelete: row => this.handleDelete(row.id) });
        return (
            <DataTable
                ref={this.tableRef}
                dataEndpoint={this.props.dataEndpoint || (this.props.isMotor ? "business/operation/moto/all" : "business/operation/all")}
                extraQueryParams={this.props.extraQueryParams || {}}
                columns={columns}
                searchPlaceholder="Plaka, müşteri veya servis no ara…"
                onRowClicked={userHasViewServicePermission ? row => this.handleServiceDetail(row.id) : undefined}
                progressPending={pending}>
            </DataTable>
        )
    }

}
export default withPermissions(withRouter(ServicesTable));
